import { Link } from "react-router-dom";

export default function CustomerLayout({ children }) {
  return (
    <>
      <div className="customer-top-nav">
        <Link className="customer-brand" to="/">
          Trishul Tours &amp; Travels
        </Link>
        <Link className="customer-website-link" to="/">
          Back to Website
        </Link>
      </div>
      {children}
      <div className="customer-footer-bottom">
        <span>© {new Date().getFullYear()} Trishul Tours &amp; Travels</span>
        <a
          href="https://inspirationsoftsolutions.com/"
          target="_blank"
          rel="noreferrer"
        >
          Designed &amp; developed by Inspiration Soft Solutions
        </a>
      </div>
    </>
  );
}
